import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { fetchJson } from '@utils/fetchJson';
import { toast } from 'react-toastify';
//import { useCustomLayoutsStore } from '../store/CustomLayoutBuilderStore';
import { API_BASE_URL } from '../../../config';
//import CustomLayoutBuilder from './CustomLayoutBuilder';
import AvailableFields from './AvailableFields';
//'File', 'Number Range Slider',
const fieldTypes = [
  'Text', 'Textarea', 'Datepicker', 'Numeric',  'Dropdown',
  'RadioList', 'CheckboxList', 'Timepicker',
  'Email', 'Web Link', 'Mobile No'
];

const iconMap = {
  'Text': 'short_text',
  'Textarea': 'notes',
  'Datepicker': 'event',
  'Numeric': 'pin',
  //'File': 'attach_file',
  'Dropdown': 'arrow_drop_down_circle',
  'RadioList': 'radio_button_checked',
  'CheckboxList': 'check_box',
  'Timepicker': 'access_time',
  //'Number Range Slider': 'tune',
  'Email': 'email',
  'Web Link': 'link',
  'Mobile No': 'phone'
};

const defaultField = {
  fieldLabel: '',
  fieldType: 'Text',
  defaultValue:null,
  isRequired: 'no',
  fieldOptions: '',
  allowMultiSelect: 'no',
  linked_with_name:null,
  minLength: null,
  maxLength: null,
  startDate: null,
  endDate: null,
  dateFormat: null,
  supportedFileTypes: null,
  numberOfFileToUpload: null,
  validationRules: null,
  startTime: '09:00 AM',
  endTime: '06:00 PM',
  displayFormat: '24-hours',
  minRangeValue: null,
  maxRangeValue: null,
  stepSize: null,
  numType: 'INT',
  isNull: 'FALSE',
  valDefault: 'USER_DEFINED',
  menuId:null,
  icon_name: 'short_text',
  linkedWith: '',
  date_selection_criteria: 'both',
  status:'active',
  itemAlign:'vertical',
};

const CustomFieldBuilder = ({ onClose, onSave,menuId,onRefresh}) => {
  const [field, setField] = useState({ ...defaultField });
  const [saving, setSaving] = useState(false);
  const [linkedModules, setLinkedModules] = useState([]);
  const [linkedFields, setLinkedFields] = useState([]);
  const [selectedModule, setSelectedModule] = useState('');
  const isValidTitle = (title) => /^[A-Za-z][A-Za-z0-9 ]{0,29}$/.test(title);
  useEffect(() => {
    
     if (menuId) {
    setField(prev => ({ ...prev, menuId }));
  }
  }, [menuId]);
  useEffect(() => {
    console.log("Updated field:", field);
  }, [field]);
  useEffect(() => {
  const fetchLinkedModules = async () => {
    try {
      const res = await fetchJson(`${API_BASE_URL}/linkedFormData`);
      setLinkedModules(res?.data || []);
    } catch (err) {
      console.error('Failed to load linked modules:', err);
    }
  };
  fetchLinkedModules();
}, []);

// const handleLinkedModuleChange = async (tableName) => {
//   setSelectedModule(tableName);
//   handleChange('linkedWith', tableName); // Save to field state

//   try {
//     const res = await fetchJson(`${API_BASE_URL}/getDefinations`, {
//       method: 'POST',
//       body: JSON.stringify({ table: `ab_${tableName}` }),
//     });
//     setLinkedFields(res?.data || []);
//   } catch (err) {
//     console.error('Failed to load field definitions:', err);
//   }
// };
const handleLinkedModuleChange = async (tableName) => {
  console.log("check linked_with_name",tableName);
  setSelectedModule(tableName);
  handleChange('linked_with_name',tableName); // Save to field state
  const selectedObject = linkedModules.find(mod => mod.table_name === tableName);
  handleChange('linkedWith', selectedObject.menuID); // Save to field state
  
  try {
    let res;

    if (tableName === "categories") {
     handleChange('fieldOptions','categoryName'); 
      // 🔁 Call category-specific API
      res = await fetchJson(`${API_BASE_URL}/categoryMasterList`, {
        method: 'POST',
        body: JSON.stringify({status:'active',getAll:"Y",is_parent:"yes",isSub:"N"}),
      });
    } else {
      // 🔁 Default linked module API
      res = await fetchJson(`${API_BASE_URL}/getDefinations`, {
        method: 'POST',
        body: JSON.stringify({ table: `ab_${tableName}` }),
      });
    }
    setLinkedFields(res?.data || []);
  } catch (err) {
    console.error('Failed to load field definitions:', err);
  }
};


  useEffect(() => {
    handleChange('icon_name', iconMap[field.fieldType] || 'short_text');
  }, [field.fieldType]);

  const handleChange = (key, value) => {
    
    if (key === "fieldLabel" && !isValidTitle(value)) {
      toast.error("Invalid title. Must start with a letter, be alphanumeric/spaces only, and max 30 characters.");
    }
    if (key === "linkedDisplayColumn" && field.linked_with_name === "categories") {
        const selectedObject = linkedFields.find(mod => mod.slug === value);
        handleChange("parentCategory",selectedObject.category_id);
    }

    setField(prev => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    if (!field.fieldLabel.trim()) {
      toast.error('Field Label is required');
      return;
    }
    setSaving(true);
    const res = await fetchJson(`${API_BASE_URL}/dynamicformfield/`, {
      method: 'PUT',
      body: JSON.stringify(field)
    });
    setSaving(false);
    if (res?.flag === 'S') {
      toast.success('Field saved successfully');
      setField({ ...defaultField });
      onSave?.();
      //onClose();
    } else {
      toast.error(res.msg || 'Failed to save field');
    }
  };

  const renderFieldOptions = () => {
    switch (field.fieldType) {
      case 'Dropdown':
      case 'RadioList':
      case 'CheckboxList':
        return (
          <div className="space-y-2">
           <div>
            <label className="text-sm font-medium text-gray-700 mb-1">Linked With (optional)</label>
            <select
              className="w-full border rounded p-2 text-sm text-gray-700 bg-gray-100 focus:outline-none"
              value={selectedModule}
              onChange={(e) => handleLinkedModuleChange(e.target.value)}
            >
              <option value="">Select Module</option>
              {linkedModules.map((mod) => (
                <option key={mod.menuID} value={mod.table_name}>
                  {mod.menuName}
                </option>
              ))}
            </select>
          </div>

          {linkedFields.length > 0 && (
              <div className="mt-2">
                <label className="text-sm font-medium text-gray-700">Select Display Field</label>
                <select
                  className="w-full border rounded p-2 text-sm text-gray-700 bg-white"
                  onChange={(e) => handleChange('linkedDisplayColumn', e.target.value)}>
                  <option value="">-- Select Label Field -- {selectedModule}</option>
                  {linkedFields.map((field) => {
                    if (selectedModule === 'categories') {
                      return (
                        <option key={field.category_id} value={field.slug}>
                          {field.categoryName}
                        </option>
                      );
                    } else {
                      return (
                        <option key={field.Field} value={field.Field}>
                          {field.Field}
                        </option>
                      );
                    }
                  })}
                </select>
              </div>
            )}
          {!field.linkedWith && (
            <div>
              <label className="text-sm font-medium text-gray-700">Options (comma-separated)</label>
              <input className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.fieldOptions} onChange={(e) => handleChange('fieldOptions', e.target.value)} placeholder="Option1, Option2, Option3" />
            </div>
          )}
          </div>
        );
      case 'Datepicker':
        return (
          <div>
            <label className="text-sm font-medium text-gray-700">Date Criteria</label>
            <select className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.date_selection_criteria} onChange={(e) => handleChange('date_selection_criteria', e.target.value)}>
              <option value="past">Past Dates Only</option>
              <option value="future">Future Dates Only</option>
              <option value="both">Both</option>
            </select>
          </div>
        );
      case 'Numeric':
        return (
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">Min Value</label>
              <input type="number" className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.minRangeValue || ''} onChange={(e) => handleChange('minRangeValue', e.target.value)} />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700">Max Value</label>
              <input type="number" className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.maxRangeValue || ''} onChange={(e) => handleChange('maxRangeValue', e.target.value)} />
            </div>
          </div>
        );
      case 'Timepicker':
        return (
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">Display Format</label>
              <select className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.displayFormat} onChange={(e) => handleChange('displayFormat', e.target.value)}>
                <option value="24-hours">24 Hours</option>
                <option value="12-hours">12 Hours</option>
              </select>
            </div>
          </div>
        );
      case 'Number Range Slider':
        return (
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">Min Value</label>
              <input type="number" className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.minRangeValue || ''} onChange={(e) => handleChange('minRangeValue', e.target.value)} />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700">Max Value</label>
              <input type="number" className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.maxRangeValue || ''} onChange={(e) => handleChange('maxRangeValue', e.target.value)} />
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700">Step Size</label>
              <input type="number" className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.stepSize || ''} onChange={(e) => handleChange('stepSize', e.target.value)} />
            </div>
          </div>
        );
       case 'Textarea':
        return (
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">Long Text Type</label>
              <select  value={field.textareaType} onChange={(e) => handleChange('textareaType', e.target.value)} className='ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded'>
                <option value="simpleTextarea">Simple Text</option>
                <option value="richTextarea">Text Editor</option>
              </select>
            </div>
          </div>
        );
        case 'File':
        return (
          <div className="grid gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">Supported File Types</label>
              <div className="flex my-2 flex-row gap-2">
                  {[
                    { label: 'Images', value: 'image' },
                    { label: 'Document File', value: 'docx' },
                    { label: 'Excel', value: 'excel' },
                    { label: 'CSV', value: 'csv' },
                    { label: 'PPT', value: 'ppt' },
                    { label: 'PDF', value: 'pdf' },
                  ].map((option) => (
                    <label key={option.value} className="flex items-center gap-2 text-sm text-gray-700">
                      <input
                        type="checkbox"
                        value={option.value}
                        checked={Array.isArray(field.supportedFileTypes) && field.supportedFileTypes.includes(option.value)}
                        onChange={(e) => {
                          const { value, checked } = e.target;
                          const updated = checked
                            ? [...(field.supportedFileTypes || []), value]
                            : (field.supportedFileTypes || []).filter((v) => v !== value);
                          handleChange('supportedFileTypes', updated);
                        }}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
            </div>
            <div>
              <label className="text-sm font-medium text-gray-700">Number of files</label>
              <input type="number" className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.numberOfFileToUpload || ''} onChange={(e) => handleChange('numberOfFileToUpload', e.target.value)} />
            </div>
          </div>
        );
      default:
        return null;
    }
  };
  const remaining = 30 - field.fieldLabel.length;

  return (
      <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
          <div className="bg-white w-full max-w-lg rounded shadow-lg relative">
            <div className="sticky top-0 z-10 bg-gray-100 border-b p-4 shadow-sm flex justify-between items-center">
              <h2 className="text-lg font-semibold text-gray-800">Add Custom Field</h2>
              <button
                  onClick={() =>onClose?.(false)}
                  className="absolute top-5 right-2 text-gray-500 hover:text-gray-700">
                  <X size={16}/>
                </button>
            </div>
            <div className='p-4 overflow-y-auto max-h-[calc(100vh-4rem)] flex-1'>
              <div className='mb-2'>
                <label className="text-sm font-medium text-gray-700 flex justify-between"><span>Field Label<span className="text-red-500">*</span></span><span className="text-sm text-gray-500">
                ({remaining}/30)</span></label>
                <input maxLength="30" className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.fieldLabel} onChange={(e) => handleChange('fieldLabel', e.target.value)} placeholder="Enter field label" />
                <div className="text-sm text-gray-500">
                Start with a letter, contain only alphanumerics/spaces.
                </div>
              </div>
              <div className='mb-2'>
                <label className="text-sm font-medium text-gray-700">Field Type</label>
                <select className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.fieldType} onChange={(e) => handleChange('fieldType', e.target.value)}>
                  {fieldTypes.map(type => (<option key={type} value={type}>{type}</option>))}
                </select>
              </div>
              {renderFieldOptions()}
              {/* <div className='mb-2'>
                <label className="text-sm font-medium text-gray-700">Default Value</label>
                <input className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.defaultValue || ''} onChange={(e) => handleChange('defaultValue', e.target.value)} placeholder="Enter default value" />
              </div> */}
              <div className='mb-2'>
                <label className="text-sm font-medium text-gray-700">Is Required?</label>
                <select className="ws-input form-input w-full text-gray-600 text-md bg-gray-100 rounded focus:outline-none text-sm px-3 py-2 pr-10 rounded" value={field.isRequired} onChange={(e) => handleChange('isRequired', e.target.value)}>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
             <div className="flex justify-end mt-4">
                <button
                  onClick={handleSubmit}
                  disabled={saving}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                >
                  {saving ? 'Saving...' : 'Save Field'}
                </button>
              </div>

            </div>
          </div>
      </div>
  );
};

export default CustomFieldBuilder;